export const FETCH_PACKAGE_DENIAL_REASONS_PENDING =
  'FETCH_PACKAGE_DENIAL_REASONS_PENDING';
export const FETCH_PACKAGE_DENIAL_REASONS_REJECTED =
  'FETCH_PACKAGE_DENIAL_REASONS_REJECTED';
export const FETCH_PACKAGE_DENIAL_REASONS_FULFILLED =
  'FETCH_PACKAGE_DENIAL_REASONS_FULFILLED';
export const SET_MAIN_DENIAL_REASON = 'SET_MAIN_DENIAL_REASON';


// WEBPACK FOOTER //
// ./src/constants/packageDenialReasons.js